import type * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type * as rxjs from 'rxjs'

import { Api } from './api.service'
import type { Feature } from './feature'
import { Name } from './name'
import type { TypeParams } from './types'

/**
 * Entity-scoped Organization collection.
 *
 * Each instance owns Organization Records for exactly one Organization Entity.
 */
export class CollectionAll extends ec.Collection<TypeParams> {
  /**
   * The Organization Entity ID whose Records this Collection manages
   */
  public readonly entityId: ents.core.dms.models.Entity.Id

  constructor(
    config: CollectionAll.Config,
    injectableDependencies: ec.InjectableDependencies,
  ) {
    const { entityId, organizationsFeature, scenarioContext$ } = config
    super(
      {
        api: new Api({
          entityId,
          includeInaccessible: true,
          organizationsFeature,
        }),
        context$: scenarioContext$,
        identify: organization => organization.id,
        name: Name.All.from(entityId),
        plugins: {
          additionalFactories: [
            new ds.input.select.singleEc.ec.Factory<TypeParams>({
              getItem: ({ name, id }) => ({
                label: name,
                value: id,
              }),
            }),
          ],
        },
      },
      injectableDependencies,
    )
    this.entityId = entityId
  }
}

export namespace CollectionAll {
  export interface Config {
    entityId: ents.core.dms.models.Entity.Id
    organizationsFeature: Feature
    scenarioContext$: rxjs.Observable<
      ents.core.admin.Context.ForScenario | undefined
    >
  }
}
